export const STUDENT_APP_IOS =
  "https://apps.apple.com/il/app/dio-for-students/id6464328476"
export const STUDENT_APP_ANDROID =
  "https://play.google.com/store/apps/details?id=com.drivewithdio.student"
export const TEACHER_APP_IOS =
  "https://apps.apple.com/il/app/dio-for-teachers/id6463775986"
export const TEACHER_APP_ANDROID =
  "https://play.google.com/store/apps/details?id=com.drivewithdio.teacher"
